<template>
  <div>
    <LogoHome />
    <v-container fluid grid-list-md text-center>
      <v-layout row wrap>
        <v-flex xs12 md4 offset-md4>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-card
                class="elevation-15 clickable transparente pa-1"
                v-ripple="{ center: true }"
                @click="abrirOpcion('Compra')"
                dark
              >
                <v-card-text>
                  <span class="overline">Comprobantes</span>
                  <p class="body-2 font-weight-thin"></p>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 md6>
              <v-card
                class="elevation-15 clickable transparente pa-1"
                v-ripple="{ center: true }"
                @click="abrirOpcion('ProveedorCrud')"
                dark
              >
                <v-card-text>
                  <span class="overline">Proveedores</span>
                  <p class="body-2 font-weight-thin"></p>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md4>
              <v-card
                class="elevation-15 clickable transparente pa-1"
                v-ripple="{ center: true }"
                @click="abrirOpcion('CompraListarLibroIva')"
                dark
              >
                <v-card-text>
                  <span class="overline">Libro IVA Compras</span>
                  <p class="body-2 font-weight-thin"></p>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 md4>
              <v-card
                class="elevation-15 clickable transparente pa-1"
                v-ripple="{ center: true }"
                @click="abrirOpcion('CompraListarPorProveedor')"
                dark
              >
                <v-card-text>
                  <span class="overline">Ficha del Proveedor</span>
                  <p class="body-2 font-weight-thin"></p>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 md4>
              <v-card
                class="elevation-15 clickable transparente pa-1"
                v-ripple="{ center: true }"
                @click="abrirOpcion('CompraListarSaldos')"
                dark
              >
                <v-card-text>
                  <span class="overline">Saldos Acreedores</span>
                  <p class="body-2 font-weight-thin"></p>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LogoHome from "@/components/LogoHome";
export default {
  name: "HomeCompra",
  components: {
    LogoHome
  },
  methods: {
    abrirOpcion(ruta) {
      if (ruta != this.$route.name)
        this.$router.push({ name: ruta, params: {} });
    }
  }
};
</script>
